import { BenchmarkRankUnivService } from "../service/asyncBatchBenchmarkRankUnivService";
import * as validations from "../utils/validations";

export class BenchmarkRankUnivFunctions {
  fnBurgissCalcPooledRankingIRRByWeight(
    universe: any,
    weight: any,
    startDate?: any,
    endDate?: any,
    currency?: string,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requireReportedValuation?: any,
    stopOn?: any,
    uniqueCellId?: string
  ) {
    universe = validations.ValidateByUniverse(universe);
    if (universe.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + universe.toString().replace("Error", "");
    } else if (universe.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when universe is defined.";
    }
    weight = validations.ValidateByWeight(weight, "Weight");
    if (weight.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + weight.toString().replace("Error", "");
    } else if (weight.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when weight is defined.";
    }
    const minDate = new Date(0).toLocaleDateString();
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();

    const validStartDate = validations.isValidBeginDate(startDate);
    if (validStartDate === false) {
      return "#INVALIDPARAMETERS - Invalid Start Date parameter.";
    }
    const validEndDate = validations.isValidEndDate(endDate);
    if (validEndDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(validEndDate, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(validStartDate, "S");
    startDate = startDate == null || startDate == "" ? null : bDate == true ? validStartDate : minDate;
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? validEndDate : minDate;
    }
    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Start Date must be prior to End Date.";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    sampleStatistic = validations.valSampleStatisticsRank(sampleStatistic, "PERCENTILE50");
    if (sampleStatistic.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + sampleStatistic.toString().replace("Error", "");
    }

    rankValue = validations.valSampleStatisticsForRankValueTwoDecimal(rankValue);
    if (String(rankValue) == "-1") {
      return "Error Invalid Input RankValue";
    }

    numSimulations = validations.valNumsimulationRank(numSimulations);
    if (String(numSimulations) == "-1") {
      return "Error Invalid Input Num simulation";
    }
    desiredSampleSize = validations.valDesiredSampleSize(desiredSampleSize);
    if (String(desiredSampleSize) == "-1") {
      return "Error Invalid Input Desired Sample Size";
    }

    requireReportedValuation = validations.validateReportedValuationRank(requireReportedValuation);
    stopOn = validations.valStopOnRank(stopOn);
    if (String(stopOn) == "-1") {
      return "Error Invalid Input stopOn";
    }
    return new BenchmarkRankUnivService().burgissCalcPooledRankingIRRByWeight(
      universe,
      weight,
      startDate,
      endDate,
      baseorlocalcurrency,
      sampleStatistic,
      rankValue,
      numSimulations,
      desiredSampleSize,
      requireReportedValuation,
      stopOn,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissCalcPooledRankingTWRRByWeight(
    universe: any,
    weight: any,
    startDate?: any,
    endDate?: any,
    currency?: string,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requireReportedValuation?: any,
    stopOn?: any,
    uniqueCellId?: string,
    advancedParameter?: string
  ) {
    universe = validations.ValidateByUniverse(universe);
    if (universe.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + universe.toString().replace("Error", "");
    } else if (universe.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when universe is defined.";
    }
    weight = validations.ValidateByWeight(weight, "Weight");
    if (weight.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + weight.toString().replace("Error", "");
    } else if (weight.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when weight is defined.";
    }
    const minDate = new Date(0).toLocaleDateString();
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();

    const validStartDate = validations.isValidBeginDate(startDate);
    if (validStartDate === false) {
      return "#INVALIDPARAMETERS - Invalid Start Date parameter.";
    }
    const validEndDate = validations.isValidEndDate(endDate);
    if (validEndDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(validEndDate, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(validStartDate, "S");
    startDate = startDate == null || startDate == "" ? null : bDate == true ? validStartDate : minDate;
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? validEndDate : minDate;
    }

    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Start Date must be prior to End Date.";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }

    sampleStatistic = validations.valSampleStatisticsRank(sampleStatistic, "PERCENTILE50");
    if (sampleStatistic.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + sampleStatistic.toString().replace("Error", "");
    }

    rankValue = validations.valSampleStatisticsForRankValueTwoDecimal(rankValue);
    if (String(rankValue) == "-1") {
      return "Error Invalid Input RankValue";
    }

    numSimulations = validations.valNumsimulationRank(numSimulations);
    if (String(numSimulations) == "-1") {
      return "Error Invalid Input Num simulation";
    }
    desiredSampleSize = validations.valDesiredSampleSize(desiredSampleSize);
    if (String(desiredSampleSize) == "-1") {
      return "Error Invalid Input Desired Sample Size";
    }

    requireReportedValuation = validations.validateReportedValuationRank(requireReportedValuation);
    stopOn = validations.valStopOnRank(stopOn);
    if (String(stopOn) == "-1") {
      return "Error Invalid Input stopOn";
    }

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }

    return new BenchmarkRankUnivService().burgissCalcPooledRankingTWRRByWeight(
      universe,
      weight,
      startDate,
      endDate,
      baseorlocalcurrency,
      sampleStatistic,
      rankValue,
      numSimulations,
      desiredSampleSize,
      requireReportedValuation,
      stopOn,
      alternateCurrrency,
      uniqueCellId,
      advancedParameter
    );
  }
  fnBurgissCalcPooledRankingDPIByWeight(
    universe: any,
    weight: any,
    endDate?: any,
    currency?: string,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requireReportedValuation?: any,
    stopOn?: any,
    uniqueCellId?: string
  ) {
    universe = validations.ValidateByUniverse(universe);
    if (universe.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + universe.toString().replace("Error", "");
    } else if (universe.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when universe is defined.";
    }
    weight = validations.ValidateByWeight(weight, "Weight");
    if (weight.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + weight.toString().replace("Error", "");
    } else if (weight.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when weight is defined.";
    }
    const minDate = new Date(0).toLocaleDateString();
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();
    const validEndDate = validations.isValidDate(endDate);
    if (validEndDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(validEndDate, "E");
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? validEndDate : minDate;
    }

    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    sampleStatistic = validations.valSampleStatisticsRank(sampleStatistic, "PERCENTILE50");
    if (sampleStatistic.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + sampleStatistic.toString().replace("Error", "");
    }

    rankValue = validations.valSampleStatisticsForRankValueTwoDecimal(rankValue);
    if (String(rankValue) == "-1") {
      return "Error Invalid Input RankValue";
    }

    numSimulations = validations.valNumsimulationRank(numSimulations);
    if (String(numSimulations) == "-1") {
      return "Error Invalid Input Num simulation";
    }
    desiredSampleSize = validations.valDesiredSampleSize(desiredSampleSize);
    if (String(desiredSampleSize) == "-1") {
      return "Error Invalid Input Desired Sample Size";
    }

    requireReportedValuation = validations.validateReportedValuationRank(requireReportedValuation);
    stopOn = validations.valStopOnRank(stopOn);
    if (String(stopOn) == "-1") {
      return "Error Invalid Input stopOn";
    }
    return new BenchmarkRankUnivService().burgissCalcPooledRankingDPIByWeight(
      universe,
      weight,
      endDate,
      baseorlocalcurrency,
      sampleStatistic,
      rankValue,
      numSimulations,
      desiredSampleSize,
      requireReportedValuation,
      stopOn,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissCalcPooledRankingRVPIByWeight(
    universe: any,
    weight: any,
    endDate?: any,
    currency?: string,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requireReportedValuation?: any,
    stopOn?: any,
    uniqueCellId?: string
  ) {
    universe = validations.ValidateByUniverse(universe);
    if (universe.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + universe.toString().replace("Error", "");
    } else if (universe.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when universe is defined.";
    }
    weight = validations.ValidateByWeight(weight, "Weight");
    if (weight.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + weight.toString().replace("Error", "");
    } else if (weight.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when weight is defined.";
    }
    const minDate = new Date(0).toLocaleDateString();
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();

    const validEndDate = validations.isValidDate(endDate);
    if (validEndDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(validEndDate, "E");
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? validEndDate : minDate;
    }

    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    sampleStatistic = validations.valSampleStatisticsRank(sampleStatistic, "PERCENTILE50");
    if (sampleStatistic.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + sampleStatistic.toString().replace("Error", "");
    }

    rankValue = validations.valSampleStatisticsForRankValueTwoDecimal(rankValue);
    if (String(rankValue) == "-1") {
      return "Error Invalid Input RankValue";
    }

    numSimulations = validations.valNumsimulationRank(numSimulations);
    if (String(numSimulations) == "-1") {
      return "Error Invalid Input Num simulation";
    }
    desiredSampleSize = validations.valDesiredSampleSize(desiredSampleSize);
    if (String(desiredSampleSize) == "-1") {
      return "Error Invalid Input Desired Sample Size";
    }

    requireReportedValuation = validations.validateReportedValuationRank(requireReportedValuation);
    stopOn = validations.valStopOnRank(stopOn);
    if (String(stopOn) == "-1") {
      return "Error Invalid Input stopOn";
    }
    return new BenchmarkRankUnivService().burgissCalcPooledRankingRVPIByWeight(
      universe,
      weight,
      endDate,
      baseorlocalcurrency,
      sampleStatistic,
      rankValue,
      numSimulations,
      desiredSampleSize,
      requireReportedValuation,
      stopOn,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissCalcPooledRankingTVPIByWeight(
    universe: any,
    weight: any[][],
    endDate?: any,
    currency?: string,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requireReportedValuation?: any,
    stopOn?: any,
    uniqueCellId?: string
  ) {
    universe = validations.ValidateByUniverse(universe);
    if (universe.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + universe.toString().replace("Error", "");
    } else if (universe.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when universe is defined.";
    }
    weight = validations.ValidateByWeight(weight, "Weight");
    if (weight.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + weight.toString().replace("Error", "");
    } else if (weight.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when weight is defined.";
    }
    const minDate = new Date(0).toLocaleDateString();
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();

    const validEndDate = validations.isValidDate(endDate);
    if (validEndDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(validEndDate, "E");
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? validEndDate : minDate;
    }

    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }

    sampleStatistic = validations.valSampleStatisticsRank(sampleStatistic, "PERCENTILE50");
    if (sampleStatistic.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + sampleStatistic.toString().replace("Error", "");
    }

    rankValue = validations.valSampleStatisticsForRankValueTwoDecimal(rankValue);
    if (String(rankValue) == "-1") {
      return "Error Invalid Input RankValue";
    }

    numSimulations = validations.valNumsimulationRank(numSimulations);
    if (String(numSimulations) == "-1") {
      return "Error Invalid Input Num simulation";
    }
    desiredSampleSize = validations.valDesiredSampleSize(desiredSampleSize);
    if (String(desiredSampleSize) == "-1") {
      return "Error Invalid Input Desired Sample Size";
    }

    requireReportedValuation = validations.validateReportedValuationRank(requireReportedValuation);
    stopOn = validations.valStopOnRank(stopOn);
    if (String(stopOn) == "-1") {
      return "Error Invalid Input stopOn";
    }
    return new BenchmarkRankUnivService().burgissCalcPooledRankingTVPIByWeight(
      universe,
      weight,
      endDate,
      baseorlocalcurrency,
      sampleStatistic,
      rankValue,
      numSimulations,
      desiredSampleSize,
      requireReportedValuation,
      stopOn,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissCalcPooledRankingIRRByCommitment(
    universe: any,
    commitment?: any,
    startDate?: any,
    endDate?: any,
    currency?: string,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requireReportedValuation?: any,
    stopOn?: any,
    uniqueCellId?: string
  ) {
    universe = validations.ValidateByUniverse(universe);
    if (universe.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + universe.toString().replace("Error", "");
    } else if (universe.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when universe is defined.";
    }

    commitment = validations.ValidateByCommitment(commitment, "Commitment");
    if (commitment.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + commitment.toString().replace("Error", "");
    } else if (commitment.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Commitment is defined.";
    }

    const minDate = new Date(0).toLocaleDateString();
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();

    const ValidStartDate = validations.isValidBeginDate(startDate);
    if (ValidStartDate === false) {
      return "#INVALIDPARAMETERS - Invalid Start Date parameter.";
    }
    const validEndDate = validations.isValidEndDate(endDate);
    if (validEndDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(validEndDate, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(ValidStartDate, "S");
    startDate = startDate == null || startDate == "" ? null : bDate == true ? ValidStartDate : minDate;
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? validEndDate : minDate;
    }

    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Start Date must be prior to End Date.";
    }

    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    sampleStatistic = validations.valSampleStatisticsRank(sampleStatistic, "PERCENTILE50");
    if (sampleStatistic.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + sampleStatistic.toString().replace("Error", "");
    }

    rankValue = validations.valSampleStatisticsForRankValueTwoDecimal(rankValue);
    if (String(rankValue) == "-1") {
      return "Error Invalid Input RankValue";
    }

    numSimulations = validations.valNumsimulationRank(numSimulations);
    if (String(numSimulations) == "-1") {
      return "Error Invalid Input Num simulation";
    }
    desiredSampleSize = validations.valDesiredSampleSize(desiredSampleSize);
    if (String(desiredSampleSize) == "-1") {
      return "Error Invalid Input Desired Sample Size";
    }

    requireReportedValuation = validations.validateReportedValuationRank(requireReportedValuation);
    stopOn = validations.valStopOnRank(stopOn);
    if (String(stopOn) == "-1") {
      return "Error Invalid Input stopOn";
    }
    return new BenchmarkRankUnivService().burgissCalcPooledRankingIRRByCommitment(
      universe,
      commitment,
      startDate,
      endDate,
      baseorlocalcurrency,
      sampleStatistic,
      rankValue,
      numSimulations,
      desiredSampleSize,
      requireReportedValuation,
      stopOn,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissCalcPooledRankingTWRRByCommitment(
    universe: any,
    commitment?: any,
    startDate?: any,
    endDate?: any,
    currency?: string,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requireReportedValuation?: any,
    stopOn?: any,
    uniqueCellId?: string,
    advancedParameter?: string
  ) {
    universe = validations.ValidateByUniverse(universe);
    if (universe.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + universe.toString().replace("Error", "");
    } else if (universe.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when universe is defined.";
    }

    commitment = validations.ValidateByCommitment(commitment, "Commitment");
    if (commitment.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + commitment.toString().replace("Error", "");
    } else if (commitment.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Commitment is defined.";
    }

    const minDate = new Date(0).toLocaleDateString();
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();

    const validStartDate = validations.isValidBeginDate(startDate);
    if (validStartDate === false) {
      return "#INVALIDPARAMETERS - Invalid Start Date parameter.";
    }
    const validEndDate = validations.isValidEndDate(endDate);
    if (validEndDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(validEndDate, "E");
    const bDate: boolean = validations.searchedDateInMeasurementDate(validStartDate, "S");
    startDate = startDate == null || startDate == "" ? null : bDate == true ? validStartDate : minDate;
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? validEndDate : minDate;
    }

    const dateCmp: boolean = validations.dateCompare(startDate, endDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Start Date must be prior to End Date.";
    }

    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    sampleStatistic = validations.valSampleStatisticsRank(sampleStatistic, "PERCENTILE50");
    if (sampleStatistic.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + sampleStatistic.toString().replace("Error", "");
    }

    rankValue = validations.valSampleStatisticsForRankValueTwoDecimal(rankValue);
    if (String(rankValue) == "-1") {
      return "Error Invalid Input RankValue";
    }

    numSimulations = validations.valNumsimulationRank(numSimulations);
    if (String(numSimulations) == "-1") {
      return "Error Invalid Input Num simulation";
    }
    desiredSampleSize = validations.valDesiredSampleSize(desiredSampleSize);
    if (String(desiredSampleSize) == "-1") {
      return "Error Invalid Input Desired Sample Size";
    }

    requireReportedValuation = validations.validateReportedValuationRank(requireReportedValuation);
    stopOn = validations.valStopOnRank(stopOn);
    if (String(stopOn) == "-1") {
      return "Error Invalid Input stopOn";
    }

    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }

    return new BenchmarkRankUnivService().burgissCalcPooledRankingTWRRByCommitment(
      universe,
      commitment,
      startDate,
      endDate,
      baseorlocalcurrency,
      sampleStatistic,
      rankValue,
      numSimulations,
      desiredSampleSize,
      requireReportedValuation,
      stopOn,
      alternateCurrrency,
      uniqueCellId,
      advancedParameter
    );
  }
  fnBurgissCalcPooledRankingDPIByCommitment(
    universe: any,
    commitment?: any,
    endDate?: any,
    currency?: string,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requireReportedValuation?: any,
    stopOn?: any,
    uniqueCellId?: string
  ) {
    universe = validations.ValidateByUniverse(universe);
    if (universe.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + universe.toString().replace("Error", "");
    } else if (universe.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when universe is defined.";
    }

    commitment = validations.ValidateByCommitment(commitment, "Commitment");
    if (commitment.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + commitment.toString().replace("Error", "");
    } else if (commitment.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Commitment is defined.";
    }

    const minDate = new Date(0).toLocaleDateString();
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();

    const validEndDate = validations.isValidDate(endDate);
    if (validEndDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(validEndDate, "E");
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? validEndDate : minDate;
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    sampleStatistic = validations.valSampleStatisticsRank(sampleStatistic, "PERCENTILE50");
    if (sampleStatistic.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + sampleStatistic.toString().replace("Error", "");
    }

    rankValue = validations.valSampleStatisticsForRankValueTwoDecimal(rankValue);
    if (String(rankValue) == "-1") {
      return "Error Invalid Input RankValue";
    }

    numSimulations = validations.valNumsimulationRank(numSimulations);
    if (String(numSimulations) == "-1") {
      return "Error Invalid Input Num simulation";
    }
    desiredSampleSize = validations.valDesiredSampleSize(desiredSampleSize);
    if (String(desiredSampleSize) == "-1") {
      return "Error Invalid Input Desired Sample Size";
    }

    requireReportedValuation = validations.validateReportedValuationRank(requireReportedValuation);
    stopOn = validations.valStopOnRank(stopOn);
    if (String(stopOn) == "-1") {
      return "Error Invalid Input stopOn";
    }
    return new BenchmarkRankUnivService().burgissCalcPooledRankingDPIByCommitment(
      universe,
      commitment,
      endDate,
      baseorlocalcurrency,
      sampleStatistic,
      rankValue,
      numSimulations,
      desiredSampleSize,
      requireReportedValuation,
      stopOn,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissCalcPooledRankingRVPIByCommitment(
    universe: any,
    commitment?: any,
    endDate?: any,
    currency?: string,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requireReportedValuation?: any,
    stopOn?: any,
    uniqueCellId?: string
  ) {
    universe = validations.ValidateByUniverse(universe);
    if (universe.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + universe.toString().replace("Error", "");
    } else if (universe.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when universe is defined.";
    }
    commitment = validations.ValidateByCommitment(commitment, "Commitment");
    if (commitment.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + commitment.toString().replace("Error", "");
    } else if (commitment.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Commitment is defined.";
    }
    const minDate = new Date(0).toLocaleDateString();
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();

    const validEndDate = validations.isValidDate(endDate);
    if (validEndDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(validEndDate, "E");
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? validEndDate : minDate;
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    sampleStatistic = validations.valSampleStatisticsRank(sampleStatistic, "PERCENTILE50");
    if (sampleStatistic.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + sampleStatistic.toString().replace("Error", "");
    }

    rankValue = validations.valSampleStatisticsForRankValueTwoDecimal(rankValue);
    if (String(rankValue) == "-1") {
      return "Error Invalid Input RankValue";
    }

    numSimulations = validations.valNumsimulationRank(numSimulations);
    if (String(numSimulations) == "-1") {
      return "Error Invalid Input Num simulation";
    }
    desiredSampleSize = validations.valDesiredSampleSize(desiredSampleSize);
    if (String(desiredSampleSize) == "-1") {
      return "Error Invalid Input Desired Sample Size";
    }

    requireReportedValuation = validations.validateReportedValuationRank(requireReportedValuation);
    stopOn = validations.valStopOnRank(stopOn);
    if (String(stopOn) == "-1") {
      return "Error Invalid Input stopOn";
    }
    return new BenchmarkRankUnivService().burgissCalcPooledRankingRVPIByCommitment(
      universe,
      commitment,
      endDate,
      baseorlocalcurrency,
      sampleStatistic,
      rankValue,
      numSimulations,
      desiredSampleSize,
      requireReportedValuation,
      stopOn,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissCalcPooledRankingTVPIByCommitment(
    universe: any,
    commitment?: any,
    endDate?: any,
    currency?: string,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requireReportedValuation?: any,
    stopOn?: any,
    uniqueCellId?: string
  ) {
    universe = validations.ValidateByUniverse(universe);
    if (universe.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + universe.toString().replace("Error", "");
    } else if (universe.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when universe is defined.";
    }
    commitment = validations.ValidateByCommitment(commitment, "Commitment");
    if (commitment.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + commitment.toString().replace("Error", "");
    } else if (commitment.toString() === "-1") {
      return "#INVALIDPARAMETERS - Filter cannot be used when Commitment is defined.";
    }
    const minDate = new Date(0).toLocaleDateString();
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();

    const validEndDate = validations.isValidDate(endDate);
    if (validEndDate === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(validEndDate, "E");
    if (endDate == null || endDate == "") {
      endDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? new Date(defaultMeasuremntDateValues.endDates).toLocaleDateString()
          : "";
    } else {
      endDate = eDate === true ? validEndDate : minDate;
    }

    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    sampleStatistic = validations.valSampleStatisticsRank(sampleStatistic, "PERCENTILE50");
    if (sampleStatistic.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + sampleStatistic.toString().replace("Error", "");
    }

    rankValue = validations.valSampleStatisticsForRankValueTwoDecimal(rankValue);
    if (String(rankValue) == "-1") {
      return "Error Invalid Input RankValue";
    }

    numSimulations = validations.valNumsimulationRank(numSimulations);
    if (String(numSimulations) == "-1") {
      return "Error Invalid Input Num simulation";
    }
    desiredSampleSize = validations.valDesiredSampleSize(desiredSampleSize);
    if (String(desiredSampleSize) == "-1") {
      return "Error Invalid Input Desired Sample Size";
    }

    requireReportedValuation = validations.validateReportedValuationRank(requireReportedValuation);
    stopOn = validations.valStopOnRank(stopOn);
    if (String(stopOn) == "-1") {
      return "Error Invalid Input stopOn";
    }
    return new BenchmarkRankUnivService().burgissCalcPooledRankingTVPIByCommitment(
      universe,
      commitment,
      endDate,
      baseorlocalcurrency,
      sampleStatistic,
      rankValue,
      numSimulations,
      desiredSampleSize,
      requireReportedValuation,
      stopOn,
      alternateCurrrency,
      uniqueCellId
    );
  }
}
